export default class SharedJwtServices {
  axiosIns = null

  jwtConfig = null

  // customAxios = axios.create({
  //   baseURL: trimEnd(process.env.VUE_APP_SERVER_URL, 'admin/'),
  // })

  constructor(axiosIns, jwtConfig) {
    this.axiosIns = axiosIns;
    this.jwtConfig = jwtConfig;
  }

  /** Countries */
  fetchCountries(params) {
    return this.axiosIns.get('/countries', { params })
  }

  fetchGeoData(params) {
    return this.axiosIns.get('/geo-data', { params })
  }

  fetchChurchRegions() {
    return this.axiosIns.get('/regions', {})
  }

  fetchMemberStatus() {
    return this.axiosIns.get('/shared/member-status', {})
  }

  fetchChurchAreas(region_id) {
    return this.axiosIns.get(`/areas`, { params: { region_id } })
  }

  fetchChurchDistricts(region, area) {
    return this.axiosIns.get(`/regions/${region}/areas/${area}/districts`, {})
  }

  fetchChurchAssemblies(region, area, district) {
    return this.axiosIns.get(`/regions/${region}/areas/${area}/districts/${district}/assemblies`, {})
  }

  getReservationReceipt(reservation_id) {
    return this.axiosIns.get(`/qr/${reservation_id}`, {})
  }

  fetchMemberTypes(params) {
    return this.axiosIns.get('/shared/member-types', { params })
  }

  fetchMemberTitles(params) {
    return this.axiosIns.get('/shared/member-titles', { params })
  }

  fetchMemberDesignations(params) {
    return this.axiosIns.get('/shared/member-designations', { params })
  }

  fetchDepartments() {
    return this.axiosIns.get('/shared/departments')
  }


  // geo endpoints
  fetchGeoRegions() {
    return this.axiosIns.get('/geo/regions')
  }

  updateGeoRegion(id, data) {
    return this.axiosIns.put(`/geo/regions/${id}`, data)
  }

  deleteGeoRegion(id) {
    return this.axiosIns.delete(`/geo/regions/${id}`)
  }

  createGeoRegion(data) {
    return this.axiosIns.post(`/geo/regions`, data)
  }

  fetchGeoAreas(params = {}) {
    return this.axiosIns.get('/geo/areas', { params })
  }

  getGeoArea(id) {
    return this.axiosIns.get(`/geo/areas/${id}`)
  }

  updateGeoArea(id, data) {
    return this.axiosIns.put(`/geo/areas/${id}`, data)
  }

  deleteGeoArea(id) {
    return this.axiosIns.delete(`/geo/areas/${id}`)
  }

  createGeoArea(data) {
    return this.axiosIns.post(`/geo/areas`, data)
  }

  fetchGeoDistricts(params = {}) {
    return this.axiosIns.get('/geo/districts', { params })
  }

  updateGeoDistrict(id, data) {
    return this.axiosIns.put(`/geo/districts/${id}`, data)
  }

  deleteGeoDistrict(id) {
    return this.axiosIns.delete(`/geo/districts/${id}`)
  }

  createGeoDistrict(data) {
    return this.axiosIns.post(`/geo/districts`, data)
  }

  fetchGeoAssemblies(params = {}) {
    return this.axiosIns.get('/geo/assemblies', { params })
  }

  updateGeoAssemblies(id, data) {
    return this.axiosIns.put(`/geo/assemblies/${id}`, data)
  }

  deleteGeoAssemblies(id) {
    return this.axiosIns.delete(`/geo/assemblies/${id}`)
  }

  createGeoAssemblies(data) {
    return this.axiosIns.post(`/geo/assemblies`, data)
  }

  // mission blocks
  fetchMissionBlocks(params = {}) {
    return this.axiosIns.get('/mission-blocks', { params })
  }

  getMissionBlock(id) {
    return this.axiosIns.get(`/mission-blocks/${id}`)
  }

  createMissionBlock(data) {
    return this.axiosIns.post('/mission-blocks', data)
  }

  updateMissionBlock(id, data) {
    return this.axiosIns.put(`/mission-blocks/${id}`, data)
  }

  deleteMissionBlock(id) {
    return this.axiosIns.delete(`/mission-blocks/${id}`)
  }

  // rmc (Regional Missions Council)
  fetchRmc(params = {}) {
    return this.axiosIns.get('/geo/rmc', { params })
  }

  getRmc(id) {
    return this.axiosIns.get(`/geo/rmc/${id}`)
  }

  createRmc(data) {
    return this.axiosIns.post('/geo/rmc', data)
  }

  updateRmc(id, data) {
    return this.axiosIns.put(`/geo/rmc/${id}`, data)
  }

  deleteRmc(id) {
    return this.axiosIns.delete(`/geo/rmc/${id}`)
  }

  // countries (managed via geo/countries; the plain /countries lookup above stays read-only)
  getGeoCountry(id) {
    return this.axiosIns.get(`/geo/countries/${id}`)
  }

  updateGeoCountry(id, data) {
    return this.axiosIns.put(`/geo/countries/${id}`, data)
  }

  bulkUpdateGeoCountriesSupported(ids, supported) {
    return this.axiosIns.post(`/geo/countries/bulk`, { ids, supported })
  }
}

